import _600e from "../../assets/img/600e.jpg";
import _600 from "../../assets/img/600.jpg";
import _500e from "../../assets/img/500e.jpg";
import PandaImg from "../../assets/img/Panda.jpg";
import fiatgrandepanda from "../../assets/img/fiatgrandepanda.jpg";
import grandehybrid from "../../assets/img/grandehybrid.jpg";
// import armani from "../../assets/img/armani.jpg";
import DobloImg from "../../assets/img/Doblo.jpg";
import e_Doblo from "../../assets/img/e-Doblo.jpg";
import ScudoImg from "../../assets/img/Scudo.jpg";
import E_Scudo from "../../assets/img/E-Scudo.jpg";
import DucatoImg from "../../assets/img/Ducato.jpg";
import e_Ducato from "../../assets/img/e-Ducato.jpg";
import _600_benzin from "../../assets/img/600_benzin.jpg";
import _600_sport from "../../assets/img/600_sport.jpg";
import GP_benzin from "../../assets/img/GP_benzin.jpg";
import topolino from "../../assets/img/Topolino.jpg";

export const vehicleImages: Record<string, string> = {
  "600e": _600e,
  "600": _600,
  "500e": _500e,
  Pandina: PandaImg,
  "Grande Panda": fiatgrandepanda,
  "Grande Panda Hybrid": grandehybrid,
  Doblo: DobloImg,
  "E-Doblo": e_Doblo,
  Scudo: ScudoImg,
  "E-Scudo": E_Scudo,
  Ducato: DucatoImg,
  "E-Ducato": e_Ducato,
  "600 Benzin": _600_benzin,
  "600 Sport": _600_sport,
  "Grande Panda Benzin": GP_benzin,
  Topolino: topolino, 
};

export const imagesOrder = [
  "600e",
  "600",
  "600 Benzin",
  "600 Sport",
  "500e",
  "Pandina",
  "Grande Panda",
  "Grande Panda Hybrid",
  "Grande Panda Benzin",
  "Topolino",
  "Doblo",
  "E-Doblo",
  "Scudo",
  "E-Scudo",
  "Ducato",
  "E-Ducato",
];

export const COMMERCIAL_MODELS = new Set([
  "Doblo",
  "E-Doblo",
  "Scudo",
  "E-Scudo",
  "Ducato",
  "E-Ducato",
]);
